import React from 'react';
import './Hero.css';

const Hero = ({ currentLanguage }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const targetPosition = element.offsetTop - navbarHeight - 20;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const getTranslation = (key) => {
    const translations = {
      en: {
        subtitle: 'Vedic Astrologer & Spiritual Guide',
        description: 'Unlock the mysteries of your destiny through ancient cosmic wisdom',
        ctaButton: 'Get Your Reading'
      },
      hi: {
        subtitle: 'वैदिक ज्योतिषी और आध्यात्मिक गुरु',
        description: 'प्राचीन ब्रह्मांडीय ज्ञान के माध्यम से अपने भाग्य के रहस्यों को खोलें',
        ctaButton: 'अपना पंचांग प्राप्त करें'
      },
      gu: {
        subtitle: 'વૈદિક જ્યોતિષી અને આધ્યાત્મિક ગુરુ',
        description: 'પ્રાચીન કોસ્મિક શાણપણ દ્વારા તમારા ભાગ્યના રહસ્યો ખોલો',
        ctaButton: 'તમારું રીડિંગ મેળવો'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  return (
    <section id="home" className="hero">
      <div className="hero-bg">
        <div className="stars"></div>
        <div className="moon"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-logo-section">
          <img src="/images/logo.jpeg" alt="Master Ankit Raval Logo" className="hero-logo" />
        </div>
        
        <div className="hero-brand">
          <h1 className="hero-title">Master Ankit Raval - Kstarplanetary</h1>
          <div className="hero-title-underline"></div>
        </div>
        
        <div className="hero-secondary-name">
          <div className="astro-name">astrovastukstar</div>
        </div>
        
        <p className="hero-subtitle">{getTranslation('subtitle')}</p>
        <p className="hero-description">{getTranslation('description')}</p>
        
        <button className="cta-button" onClick={() => scrollToSection('contact')}>
          <i className="fas fa-crystal-ball"></i>
          <span>{getTranslation('ctaButton')}</span>
        </button>
      </div>
      
      <div className="scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;